"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _grid = require("@rebass/grid");
var _router = require("next/router");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _getUnitTypeConsts = _interopRequireDefault(require("../constants/getUnitTypeConsts"));
var _graphql = require("../generated/graphql");
var _Divider = _interopRequireDefault(require("./Divider"));
var _BookingReviewForm = _interopRequireDefault(require("./BookingReviewForm"));
var _useGetPageSlugByLocale = _interopRequireDefault(require("../hooks/useGetPageSlugByLocale"));
var _ReviewDone = _interopRequireDefault(require("./ReviewDone"));
var _LeaveReview = _interopRequireDefault(require("./LeaveReview"));
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const LeaveBookingReview = ({
  booking,
  leftReview: isReviewDone,
  setLeftReview,
  rentalUnit,
  isAnonymous,
  loading
}) => {
  const [mutate] = (0, _graphql.useLeaveReviewMutation)();
  const [unauthenticatedMutate] = (0, _graphql.useLeaveUnauthenticatedReviewMutation)();
  const {
    getPageSlugByLocale
  } = (0, _useGetPageSlugByLocale.default)();
  const accommodationPageSlug = getPageSlugByLocale('ACCOMMODATION');
  const intl = (0, _reactIntl.useIntl)();
  const {
    query: {
      bookingHash
    },
    locale
  } = (0, _router.useRouter)();
  const handleSubmit = async values => {
    if (isAnonymous) {
      if (!bookingHash) {
        return;
      }
      await unauthenticatedMutate({
        variables: {
          input: _objectSpread({
            bookingHash: bookingHash
          }, values)
        }
      });
      setLeftReview(true);
      return;
    }
    if (!booking?.id) {
      return;
    }
    await mutate({
      variables: {
        input: _objectSpread({
          bookingId: booking.id
        }, values)
      },
      update: (cache, {
        data: payload
      }) => {
        const opts = {
          id: `${booking?.__typename ?? 'Booking'}:${booking.id}`,
          fragment: _graphql.OrderItemFragmentDoc,
          fragmentName: 'OrderItem'
        };
        const old = cache?.readFragment(opts);
        if (!old || !payload?.leaveReview.review) {
          return;
        }
        cache.writeFragment(_objectSpread(_objectSpread({}, opts), {}, {
          data: _objectSpread(_objectSpread({}, old), {}, {
            review: payload?.leaveReview.review
          })
        }));
      }
    });
    setLeftReview(true);
  };
  if (isReviewDone) {
    return __jsx(_ReviewDone.default, {
      orderItem: booking,
      setLeftReview: setLeftReview,
      isAnonymous: isAnonymous,
      pushUrl: "/[accommodation]/[slug]",
      pathName: `/${accommodationPageSlug}/${rentalUnit?.slug}`,
      locale: locale
    });
  }
  return __jsx(_react.default.Fragment, null, rentalUnit && __jsx(_LeaveReview.default, {
    item: booking,
    object: rentalUnit,
    webpThumbnail: rentalUnit?.webpThumbnail,
    jpegThumbnail: rentalUnit?.jpegThumbnail,
    locale: locale,
    isAnonymous: isAnonymous,
    loading: loading,
    pushUrl: `/${accommodationPageSlug}/${rentalUnit?.slug}`,
    strapline: rentalUnit?.accommodation.hasPublicPage && rentalUnit?.accommodation.name || undefined,
    subtitle: (0, _getUnitTypeConsts.default)(intl)[rentalUnit.type].translation
  }), __jsx(_grid.Box, {
    order: 2,
    width: ['100%', null, '70%', '60%']
  }, __jsx(_Divider.default, {
    mt: 0,
    mb: 8
  }), __jsx(_BookingReviewForm.default, {
    handleSubmit: handleSubmit
  })));
};
var _default = exports.default = LeaveBookingReview;